import React, { useEffect, useState } from "react";
import { Box, Drawer, IconButton, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";
import WorkersMultiSelectDropdown from "../../../../components/workersMultiSelection";
import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import { getStatusBadgeBackgroundColor } from "../../../../constants/statusPalette";

export default function AttendanceFilterDrawer({
  // open,
  // onClose,
  // selectedFilter,
  // setSelectedFilter,
  // setIsFilterApplied,
    open,
  onClose,
  filters,
  setFilters,
  setIsFilterApplied,
}) {
  const { t } = useTranslation();




const STATUS_NORMALIZATION_MAP = {
  clock_in: [
    "clock_in",
    "clockin",
    "check_in",
    "checkin",
    "on_time_clock_in",
    "ontimeclockin",
    "ontime",
    "on_time",
    "present",
  ],

  early_clock_in: [
    "early_clock_in",
    "earlyclockin",
    "early_check_in",
    "early_arrival",
    "earlyarrival",
  ],

  late_clock_in: [
    "late_clock_in",
    "lateclockin",
    "late",
    "late_arrival",
    "latearrival",
  ],

  on_break: [
    "start_break",
    "startbreak",
    "break_start",
    "breakstart",
    "on_break",
    "onbreak",
  ],

  break_end: [
    "end_break",
    "endbreak",
    "break_end",
    "breakend",
    "back_from_break",
    "backfrombreak",
  ],

  clock_out: ["clockout", "clock_out", "check_out", "checkout"],

  early_clock_out: [
    "early_clock_out",
    "earlyclockout",
    "early_clockout",
    "early_out",
    "earlyout",
  ],

  late_clock_out: ["late_clock_out", "lateclockout", "late_out", "lateout"],

  vacation: ["leave", "on_leave", "onleave", "vacation", "vacations"],

  on_half_leave: ["half_leave", "halfleave", "on_half_leave", "onhalfleave"],

  absent: ["absent", "not_done", "absence"],
};

/** Align router/API/camelCase values with drawer chip keys (snake_case for query string). */
const normalizeAttendanceStatus = (rawStatus = "") => {
  let s = String(rawStatus ?? "").trim();
  if (!s) return "";

  s = s
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[\s-]+/g, "_")
    .toLowerCase();

  for (const [canonical, variants] of Object.entries(STATUS_NORMALIZATION_MAP)) {
    if (variants.includes(s)) {
      return canonical;
    }
  }

  return s;
};


  // Your attendance filters
// const statusOptions = [
//   { key: "clock_in", label: t("attendanceFilter.statuses.clock_in") },
//   { key: "on_break", label: t("attendanceFilter.statuses.on_break") },
//   { key: "break_end", label: t("attendanceFilter.statuses.break_end") },
//   { key: "clock_out", label: t("attendanceFilter.statuses.clock_out") },
//   { key: "absent", label: t("attendanceFilter.statuses.absent") },
//   { key: "vacation", label: t("attendanceFilter.statuses.vacation") },
//   { key: "on_half_leave", label: t("attendanceFilter.statuses.on_half_leave") },
//   { key: "present", label: t("attendanceFilter.statuses.present") },
//   { key: "late", label: t("attendanceFilter.statuses.late") },
// ];
/** One row = legend dot + filter chip (same labels as dashboard map legend). */
const attendanceStatusLegendAndFilters = [
  { key: "clock_in", colorKey: "CLOCK_IN", label: t("clock_in") },
  { key: "early_clock_in", colorKey: "EARLY_CLOCK_IN", label: t("early_clock_in") },
  { key: "late_clock_in", colorKey: "LATE_ARRIVAL", label: t("late_clock_in") },
  { key: "on_break", colorKey: "BREAK", label: t("break_start") },
  { key: "break_end", colorKey: "BREAK_END", label: t("break_end") },
  { key: "clock_out", colorKey: "CLOCK_OUT", label: t("clock_out") },
  { key: "early_clock_out", colorKey: "EARLY_CLOCK_OUT", label: t("early_clock_out") },
  { key: "late_clock_out", colorKey: "LATE_CLOCK_OUT", label: t("late_clock_out") },
  { key: "vacation", colorKey: "ON_LEAVE", label: t("on_leave") },
  { key: "on_half_leave", colorKey: "ON_HALF_LEAVE", label: t("on_half_leave") },
  { key: "absent", colorKey: "ABSENT", label: t("absent") },
];

  // const [localFilter, setLocalFilter] = useState(selectedFilter);
const token = useSelector((state) => state.auth.token);
const decryptedToken = token ? decryptToken(token) : null;
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;

const [workers, setWorkers] = useState([]);
const [localFilters, setLocalFilters] = useState(filters);
  // Sync when drawer opens
  // useEffect(() => {
  //   if (open) setLocalFilter(selectedFilter);
  // }, [open, selectedFilter]);



  const fetchWorkers = async () => {
  try {
    const res = await fetch(
      `${BASE_URL}/public/workers?no_pagination=true&company_id=${companyId}&status=active`,
      { headers: { Authorization: `Bearer ${decryptedToken}` } }
    );

    const data = await res.json();
    const list = data?.data?.records || [];

    setWorkers([
      { label: t("all"), value: "all" },
      ...list.map((w) => ({
        label: `${w.first_name} ${w.last_name}`,
        value: w.id,
        email: w.email,
      })),
    ]);
  } catch (e) {
    console.error("Worker fetch error", e);
  }
};


  useEffect(() => {
    if (open) {
      setLocalFilters(filters);
      fetchWorkers();
    }
  }, [open, filters]);
  // Apply filter
  // const apply = () => {
  //   setSelectedFilter(localFilter);
  //   setIsFilterApplied(!!localFilter);
  //   onClose();
  // };

  const apply = () => {
    const statusKey = normalizeAttendanceStatus(localFilters.status);
    const next = {
      ...localFilters,
      status: statusKey || localFilters.status || "",
    };
    setFilters((prev) => ({ ...prev, ...next }));
    setIsFilterApplied(Boolean(next.status || next.worker));
    onClose();
  };
//   const apply = () => {
//   setFilters(localFilters);
//   setIsFilterApplied(
//     Boolean(localFilters.status || localFilters.worker)
//   );
//   onClose();
// };

  // Clear filter
  // const clear = () => {
  //   setLocalFilter("");
  //   setSelectedFilter("");
  //   setIsFilterApplied(false);
  //   onClose();
  // };
  const clear = () => {
  const cleared = { status: "", worker: "" };
  setLocalFilters(cleared);
  setFilters((prev) => ({ ...prev, ...cleared }));
  setIsFilterApplied(false);
  onClose();
};

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 550 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#E7EBEE",
          zIndex: 10,
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #ccc",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>

          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
            {t("attendanceFilter.title")}

          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Status Section */}
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 500,
              color: "#2C384C",
              textAlign: "left",
              pt: 2,
            }}
          >
  {t("attendanceFilter.statusHeading")}
          </CustomText>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 2,
              mt: 2,
              mb: 1,
            }}
          >
            {attendanceStatusLegendAndFilters.map((item) => (
              <Box
                key={item.key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                }}
              >
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    borderRadius: "50%",
                    backgroundColor: getStatusBadgeBackgroundColor(
                      item.colorKey
                    ),
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#44546F",
                    fontFamily: "Poppins, sans-serif",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {attendanceStatusLegendAndFilters.map((opt) => {
const isActive =
  normalizeAttendanceStatus(localFilters.status) === opt.key;
              return (
                <Button
                  key={opt.key}
                  variant="outlined"
                  size="small"
//                   onClick={() =>
//                     // setLocalFilter(isActive ? "" : opt.key)
//                     setLocalFilters((p) => ({
//   ...p,
//   status: isActive ? "" : opt.key,
// }))

//                   }
onClick={() =>
  setLocalFilters((p) => ({
    ...p,
    status: isActive ? "" : opt.key,
  }))
}
                  sx={{
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isActive ? "#006EC2" : "#363333",
                    border: isActive
                      ? "2px solid #006EC2"
                      : "2px solid #091E4224",
                  }}
                >
                  {opt.label}
                </Button>
              );
            })}
          </Box>


<Box mt={3}>
  <WorkersMultiSelectDropdown
    label={t("employee")}
    // values={
    //   localFilters.worker_id ? [localFilters.worker_id] : []
    // }
values={localFilters.worker ? [localFilters.worker] : []}

    options={workers}
    enableSearch
    isSingleSelect
    onChange={(e) => {
      const value = e.target.value?.[0] || "";
      setLocalFilters((p) => ({
        ...p,
        worker: value === "all" ? "" : value,
      }));
    }}
    renderValue={(selected) =>
      workers.find((w) => w.value === selected[0])?.label || ""
    }
    renderOption={(props, option) => (
      <li {...props}>
        <span>{option.label}</span>
        {option.email && (
          <span style={{ fontSize: 12, color: "#888" }}>
            {option.email}
          </span>
        )}
      </li>
    )}
  />
</Box>



          {/* Buttons */}
          <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
            {/* APPLY BUTTON */}
            <CustomButton
              onClick={apply}
              size="medium"
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" width={16} height={16} />
                  {t("attendanceFilter.apply")}
                </Box>
              }
            />

            {/* CLEAR BUTTON */}
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
              }}
            >
              {t("attendanceFilter.clear")}

            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}
